import { theme } from "@lvt/material";
import { createTheme, makeStyles, createStyles } from "@material-ui/core";


export const useHeaderStyles = makeStyles(() =>
    createStyles({
        drawer: {
            width: "100%", //drawerwidth
        },
        icon: {
            color: theme.palette.common.white,
            "&:hover": {
                cursor: "pointer",
                color: theme.palette.grey[400],
            },
        },
        pickerBackground: {
            backgroundColor: "white",
        },
        modal: {
            width: "80%",
            maxHeight: 800,
        },
        paper: {
            width: "80%",
            maxHeight: 435,
        },
        button: {
            fontFamily: "Source Sans Pro",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "16px",
            height: "32px",
            alignSelf: "center",
            backgroundColor: theme.palette.info.main,
            color: theme.palette.info.contrastText,
            "&:hover": {
                backgroundColor: theme.palette.info.dark,
            },
        },
    }),
);

export const pickerStyles = createTheme({
    palette: {
        primary: theme.palette.primary,
        secondary: theme.palette.secondary,
    },
    overrides: {
        MuiFormLabel: {
            root: {
                font: `${theme.typography.caption}`,
            },
        },
        MuiFormControl: {
            root: {
                width: "15%",
                marginBottom: "2px",
                marginTop: "2px",
                marginRight: "1em",
                borderRadius: "4px 4px 0 0",
            },
        },
        MuiInputBase: {
            input: {
                font: `${theme.typography.body2}`,
                padding: "0.5em 0 0.5em 1em",
            },
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: theme.palette.secondary.dark,
                "&:hover": {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
        },
        MuiPickersClockPointer: {
            thumb: {
                borderColor: theme.palette.secondary.dark,
            },
            noPoint: {
                backgroundColor: theme.palette.secondary.dark,
            },
        },
    },
});
